import produce from 'immer';
import create from 'zustand';

const useContentFormatTypesStore = create(set => ({
  contentFormatTypes: [],
  set: fn => set(produce(fn)),
}));

export default useContentFormatTypesStore;
